import Main from './main.vue';
import { isVNode } from '../../utils'

let instance;
let calkBackList = [];
let seed = -1;
let LocationConstructor = Vue.extend(Main);
let selectCityObj = null
let locateObj = null
try {
    selectCityObj = JSON.parse(localStorage.selectCityObj)
} catch (e) {
    selectCityObj = null
}
try {
    locateObj = JSON.parse(localStorage.locateObj)
} catch (e) {
    locateObj = null
}
let currentLocation = locateObj && locateObj.cityName && locateObj.tcCityId && locateObj.elCityId ? locateObj : {
    isSuccess: false,//res.latitude&&res.longitude,
    latitude: "",//	纬度	Number	-	-
    longitude: "",//	经度	Number	-	-
    speed: '',//	速度	Number	-	只有微信H5/微信小程序/外部H5
    accuracy: '',//	位置的精确度	Number	-	只有微信H5/微信小程序/外部H5
    altitude: '',//	高度	Number	-	只有百度小程序支持/外部H5
    provName: '上海',//	省份名称	String	-	-
    cityName: '上海',//	城市名称	String	-	-
    tcProvId: '25',//	同程省份Id	Number	-	-
    tcCityId: '321',//	同程城市Id	Number	-	-
    elCityId: '0201',//	艺龙城市Id	String	-	不支持同程APP
    threeCode: "SHA"
}
const Location = function (...options) {
    let data = options && options[0] && options[0].data || null
    let calkBack = options && options[0] && options[0].callback || null
    //有历史缓存直接返回历史定位数据
    if (currentLocation.isSuccess) {
        currentLocation.action = 'init'
        calkBack({
            currentLocation,
            historyLocation: locateObj,
            historySelectCity: selectCityObj
        })
        _locationTrack(currentLocation)
        return
    }
    calkBackList.push(calkBack);
    //无历史缓存走ip定位
    Vue.prototype.$http({
        method: 'get',
        url: '/actgateway/marketcenter.java.activity.resource.service/v2/city/getCityInfoByIp'

    }).then(({ data }) => {
        if (data.code === '0000') {
            let res = data.result
            currentLocation = {
                isSuccess: res.latbd && res.lonbd,
                latitude: res.latbd,//	纬度	Number	-	-
                longitude: res.lonbd,//	经度	Number	-	-
                speed: '',//	速度	Number	-	只有微信H5/微信小程序/外部H5
                accuracy: '',//	位置的精确度	Number	-	只有微信H5/微信小程序/外部H5
                altitude: '',//	高度	Number	-	只有百度小程序支持/外部H5
                provName: res.provName,//	省份名称	String	-	-
                cityName: res.nameShort,//	城市名称	String	-	-
                tcProvId: res.provId,//	同程省份Id	Number	-	-
                tcCityId: res.id,//	同程城市Id	Number	-	-
                elCityId: res.eRegion && res.eRegion.euId,//	艺龙城市Id	String	-	不支持同程APP
                threeCode: res.threeCode,
                action: 'ip_locate'
            }
            calkBackList.forEach(calkBack => {
                calkBack({
                    currentLocation,
                    historyLocation: locateObj,
                    historySelectCity: selectCityObj
                })
            })
            localStorage.locateObj = JSON.stringify(currentLocation)
        } else {
            currentLocation.action = 'init'
            calkBackList.forEach(calkBack => {
                calkBack({
                    currentLocation,
                    historyLocation: locateObj,
                    historySelectCity: selectCityObj
                })
            })
        }
        _locationTrack(currentLocation)
    }).catch(() => {
        currentLocation.action = 'init'
        calkBackList.forEach(calkBack => {
            calkBack({
                currentLocation,
                historyLocation: locateObj,
                historySelectCity: selectCityObj
            })
        })
        _locationTrack(currentLocation)
    })


    if (seed !== -1 && (!data || (data && !data.retry))) {
        return
    }

    instance = new LocationConstructor({
        data: data,
        methods: {
            closeFn() {
                this.isVisiable = false
            },
            changeFn() {
                this.isVisiable = false
                currentLocation.action = 'handle_select'
                this.$UI.citySelect({
                    data: {
                        locateType: 2,
                    },
                    callback: function (res) {
                        for (let key in currentLocation) {
                            if (res[key]) {
                                currentLocation[key] = res[key]
                            } else {
                                currentLocation[key] = ''
                            }
                        }
                        calkBackList.forEach(calkBack => {
                            calkBack({
                                currentLocation,
                                historyLocation: locateObj,
                                historySelectCity: selectCityObj
                            })
                        })
                    },
                })
                _locationTrack(currentLocation)
            },
            helpFn() {
                this.isVisiable = false
                currentLocation.action = 'help_start'
                _locationTrack(currentLocation)
                calkBackList.forEach(calkBack => {
                    calkBack({
                        currentLocation,
                        historyLocation: locateObj,
                        historySelectCity: selectCityObj
                    })
                })
                window.AllBridge.getLocation(
                    { cacheType: instance.appCacheType || '3' }
                ).then((res) => {
                    currentLocation = res
                    currentLocation.action = 'help_success'
                    currentLocation.isSuccess = true
                    localStorage.locateObj = JSON.stringify(currentLocation)
                    _locationTrack(currentLocation)
                    calkBackList.forEach(calkBack => {
                        calkBack({
                            currentLocation,
                            historyLocation: locateObj,
                            historySelectCity: selectCityObj
                        })
                    })
                }).catch((e) => {
                    currentLocation.action = 'help_fail'
                    _locationTrack(currentLocation)
                    calkBackList.forEach(calkBack => {
                        calkBack({
                            currentLocation,
                            historyLocation: locateObj,
                            historySelectCity: selectCityObj
                        })
                    })
                })

            }
        }
    });

    if (isVNode(instance.message)) {
        instance.$slots.default = [instance.message];
        instance.message = null;
    } else {
        delete instance.$slots.default;
    }
    seed++
    instance.$mount();
    if (data && data.el) {
        data.el.appendChild(instance.$el);
    } else {
        document.body.appendChild(instance.$el);
    }
    return instance;
};
function _locationTrack(currentLocation) {
    window.AllBridge
        .allEventTrack({
            category: "alle_page",
            action: `all_Location_${currentLocation.action}_event`,
            value: {
                "isDefault": currentLocation.isSuccess ? 1 : 0,
                "latLon": `${currentLocation.longitude},${currentLocation.latitude}`,
                "nCity": `${currentLocation.provName},${currentLocation.cityName}`
            }
        })
}


export default Location;